import { Container, Row, Col, Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import ProjectSummary from './Projectdashbord/Projectdashbord';
import ProjectTasks from './tasks/ProjectTasks';
import ProjectFiles from './files/ProjectFiles';
import ProjectLogs from './logs/ProjectLogs';
import ProjectTeams from './team/ProjectTeams';
import ProjectActivities from './activities/ProjectActivities';
import ProjectReport from './reports/ProjectReport';
import ProjectCalendar from './calendar/ProjectCalendar';

const ProjectsDetail = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    
    const projectData = {
        id: '12345',
        name: 'eCommerce Website',
        client: 'Netclues Technologies'
    };

    // Get dynamic heading based on current section
    const getSectionHeading = () => {
        if (currentPath === '/projects/details' || currentPath === '/projects/detail' || currentPath.includes('/dashboard')) return 'Project Dashboard';
        if (currentPath.includes('/tasks')) return 'Project Tasks';
        if (currentPath.includes('/files')) return 'Project Files';
        if (currentPath.includes('/logs')) return 'Project Logs';
        if (currentPath.includes('/teams')) return 'Project Teams';
        if (currentPath.includes('/activities')) return 'Project Activities';
        if (currentPath.includes('/report')) return 'Project Report';
        if (currentPath.includes('/calendar')) return 'Project Calendar';
        return projectData.name;
    };
    
    // Check if we're in specific sections
    const isDashboardSection = currentPath === '/projects/details' || currentPath === '/projects/detail' || currentPath === '/projects/detail/dashboard' || currentPath === '/projects/detail/summary';
    const isTasksSection = currentPath === '/projects/detail/tasks';
    const isFilesSection = currentPath === '/projects/detail/files' || currentPath === '/projects/files';
    const isLogsSection = currentPath === '/projects/detail/logs' || currentPath === '/projects/logs';
    const isTeamsSection = currentPath === '/projects/detail/teams' || currentPath === '/projects/teams';
    const isActivitiesSection = currentPath === '/projects/detail/activities' || currentPath === '/projects/activities';
    const isReportSection = currentPath === '/projects/detail/report' || currentPath === '/projects/report';
    const isCalendarSection = currentPath === '/projects/detail/calendar' || currentPath === '/projects/calendar';

    const getTaskPrefix = () => {
        if (currentPath === '/projects/details' || currentPath === '/projects/detail' || currentPath.includes('/dashboard')) return 'Project Dashboard';
        if (currentPath.includes('/tasks')) return 'Project Task';
        if (currentPath.includes('/logs')) return 'Project Log';
        if (currentPath.includes('/files')) return 'Project File';
        if (currentPath.includes('/teams')) return 'Project Team';
        if (currentPath.includes('/activities')) return 'Project Activity';
        if (currentPath.includes('/report')) return 'Project Report';
        if (currentPath.includes('/calendar')) return 'Project Calendar';
        return 'Project Task';
    };

    return (
        <Container fluid className="projects-page">
            <Row>
                <Col lg={4}>
                    <h1 className="display-1">{getSectionHeading()}</h1>
                    <div className="display-2">{projectData.client}</div>
                </Col>
                <Col lg={8}>
                    <div className="text-end">
                        <Nav className="c-nav-tabs">
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/projects/detail"
                                    active={isDashboardSection}
                                >
                                    Dashboard
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/projects/detail/tasks"
                                    active={isTasksSection}
                                >
                                    Tasks
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/projects/detail/files"
                                    active={isFilesSection}
                                >
                                    Files
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/projects/detail/logs"
                                    active={isLogsSection}
                                >
                                    Logs
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/projects/detail/teams"
                                    active={isTeamsSection}
                                >
                                    Teams
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/projects/detail/activities"
                                    active={isActivitiesSection}
                                >
                                    Activities
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/projects/detail/report"
                                    active={isReportSection}
                                >
                                    Report
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/projects/detail/calendar"
                                    active={isCalendarSection}
                                >
                                    Calendar
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                </Col>
            </Row>
            <Row className="mt-0 gy-4">
                <Col lg={12}>
                    {isDashboardSection && (
                        <ProjectSummary 
                            projectId={projectData.id} 
                            projectName={projectData.name}
                        />
                    )}
                    {isTasksSection && (
                        <ProjectTasks 
                            projectId={projectData.id} 
                            projectName={projectData.name}
                            taskPrefix={getTaskPrefix()}
                        />
                    )}
                    {isFilesSection && (
                        <ProjectFiles 
                            projectId={projectData.id} 
                            projectName={projectData.name}
                        />
                    )}
                    {isLogsSection && (
                        <ProjectLogs 
                            projectId={projectData.id} 
                            projectName={projectData.name}
                        />
                    )}
                    {isTeamsSection && (
                        <ProjectTeams 
                            projectId={projectData.id} 
                            projectName={projectData.name}
                        />
                    )}
                    {isActivitiesSection && (
                        <ProjectActivities 
                            projectId={projectData.id} 
                            projectName={projectData.name}
                        />
                    )}
                    {isReportSection && (
                        <ProjectReport 
                            projectId={projectData.id} 
                            projectName={projectData.name}
                        />
                    )}
                    {isCalendarSection && (
                        <ProjectCalendar 
                            projectId={projectData.id} 
                            projectName={projectData.name}
                        />
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default ProjectsDetail;